import type { MessageSharePresentationDto } from "@multi-chat/shared";

type Translate = (key: string, options?: Record<string, unknown>) => string;

const SHARE_TYPE_KEYS: Record<string, string> = {
  share: "inbox.share.instagramPost",
  ig_post: "inbox.share.instagramPost",
  ig_reel: "inbox.share.instagramReel",
  reel: "inbox.share.instagramReel",
  story: "inbox.share.instagramStory",
  ig_story: "inbox.share.instagramStory",
  story_mention: "inbox.share.storyMention",
};

export function shareTypeLabel(shareType: string, t: Translate): string {
  const key = SHARE_TYPE_KEYS[shareType] ?? "inbox.share.generic";
  return t(key);
}

/** @deprecated Use shareTypeLabel inside MessageShareCard */
export function shareMessageLabel(
  presentation: MessageSharePresentationDto,
  t: Translate,
): string {
  const base = shareTypeLabel(presentation.shareType, t);
  if (presentation.username) {
    return `${base}: ${presentation.username}`;
  }
  if (presentation.captionSnippet) {
    return `${base}: ${presentation.captionSnippet}`;
  }
  if (presentation.title) {
    return `${base}: ${presentation.title}`;
  }
  return base;
}
